import React from 'react'
import RedeemAmazonMethod from '../../components/RedeemMethod/RedeemAmazonMethod';
import classes from './redeemPage.module.css';
import useDarkOffersBackground from '../../hooks/useDarkOffersBackground';
const Spacer = require('react-spacer')



export default function RedeemAmazon() {
  useDarkOffersBackground();
  return (
    <>
    <h2 className={classes.sponsoredOffersHeading}>Choose your Reward Amount:</h2>
    <RedeemAmazonMethod/>
    <Spacer height={'100px'}/>
    </>
  )
}
